import React, { memo } from "react";

const FilteringComponent = memo(() => {
    return <div />;
});

export default FilteringComponent;
